<template>
  <div>
    <SearchFacet
      v-model="selection.titles"
      kind="title"
      title="Titel"
      :items="data.titles"
      :loading="isLoading"
      style="margin-bottom: 0.75rem;"
    />
  </div>
</template>

<script>
 import SearchFacet from '@/components/SearchFacet.vue'

 import api from '@/api'
 import utilsMixin from '@/mixins/utils.js'

 import { debounce } from '@/utils/misc.js'

 import { createValidator } from '@/utils/validation.js'
 import { createMapper, createWatchers } from '@/utils/mapping.js'

 const validator = createValidator('search-form')
 const mapper = createMapper('search-form')

 export default {
   mixins: [utilsMixin],
   components: { SearchFacet },
   watch: {
     ...createWatchers('$route.query', 'syncFromQuery', { ignore: ['page','view'] }),
     'selection': {
       handler: 'syncWithQuery',
       deep: true
     }
   },
   data() {
     return {
       isLoading: false,
       data: {
	 titles: []
       },
       selection: {
	 titles: []
       }
     }
   },
   computed: {
     canSubmit() {
       return !!this.query.term
     },
     query() {
       const query = mapper.fromURL(this.$route.query)
       if (validator.isValid(query)) {
	 return validator.clean(query)
       }
       else {
	 return {}
       }
     }
   },
   methods: {
     load: debounce(async function() {
       if (this.isLoading) {
	 return
       }

       this.isLoading = true

       const { total, facets } = await api.fetchSearchFacets(this.query)
       const { titles } = facets
       this.data = { titles }

       this.isLoading = false
     }, 50),
     async tryToLoad() {
       if (this.canSubmit) {
	 await this.load()
       }
     },
     async syncFromQuery(newValue, oldValue) {
       if (!this.isDeepEqual(newValue, oldValue)) {
	 const { titles = [] } = this.query

	 this.selection = { titles }

	 await this.tryToLoad()
       }
     },
     async syncWithQuery() {
       const { titles } = this.selection
       
       // change facet related params only
       const query = mapper.toURL({
	 ...validator.clean({
	   ... mapper.fromURL(this.$route.query),
	   titles
	 }),
	 // ... but drop current page
       }, { ignore: ['page'] })
        query['p'] = 1
       this.$router.push({
         query
       })

       await this.tryToLoad()
     }
   }
 }
</script>
